<template>
  <div class="create-goods-category bg-white ">
    <div class="flex shadow-border-b mdmax:flex-col">
      <div class="flex-1 p-6 shadow-border-r mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto">
        <p class="font-bold text-lg mb-6">Kategori Barang</p>
        <div class="mb-6">
          <TextField type="text" label="Nama Kategori" placeholder="Nama Kategori" v-model="payloads.name" />
        </div>
        <div class="">
          <Textarea type="text" label="Deskripsi (optional)" placeholder="Masukan deskripsi" v-model="payloads.category_description" />
        </div>
      </div>
      <div class="flex-1 p-6 mdmax:w-full mdmax:flex-auto">
        <p class="font-bold text-lg mb-6">Sub Kategori</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Terdapat Sub</label>
          <CustomSelect :options="subOptions" v-model="hasSub" default="Tidak" />
        </div>
        <div class="" v-if="hasSub === 'Ya'">
          <TextField type="text" label="Nama Sub Ketgori" v-model="payloads.sub_categories" placeholder="Masukan sub ketegori gunakan tanda koma jika lebih dari satu" />
        </div>
      </div>
    </div>
    <div class="flex justify-end gap-6 p-6">
      <Button buttonText="Simpan" type="primary" @action="save()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Textarea: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Textarea'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect')
  },
  data() {
    return {
      subOptions: ['Ya', 'Tidak'],
      hasSub: '',
      name: '',
      subCategoryName: '',
      description: '',
      payloads: {
        name: '',
        category_description: '',
        sub_categories: ''
      }
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile'])
  },
  methods: {
    ...mapActions('master', ['createGoodsCategory']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    save() {
      this.showLoading()
      this.createGoodsCategory({
        payloads: this.payloads
      }).then(() => {
        this.hideLoading()
        this.$router.push('/goods-category')
      })
    }
  }
}
</script>
